// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14PqE","type":"styles_type__2opvt","choices":"styles_choices__2Uor0"};